import React from 'react';
import styled from 'styled-components';
import ProgressBar from 'components/elements/ProgressBar';
import FadeIn from 'components/utility/FadeIn';

const Wrapper = styled.div`
  display: block;
  width: 100%;
  text-align: center;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  .index {
    text-align: center;
    font-size: 36px;
    padding-bottom: 4px;
    display: inline-block;
  }
  .question {
    text-align: center;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -1px;
  }
  .answer-wrapper {
    margin-top: 32px;
    padding: 20px;
    transition: 0.2s all ease;
  }
`;

const AnswerButton = styled.button`
  cursor: pointer;
  width: 100%;
  border: 1px solid #ed9b88;
  background-color: transparent;
  border-radius: 4px;
  height: 56px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 16px;
  & + & {
    margin-top: 8px;
  }
  &:active {
    background-color: #ed9b88;
  }
  &:focus {
    outline: 0;
  }
  transition: 0.2s all ease;
  @media only screen and (min-width: 501px) {
    &:hover {
      background-color: #ed9b88;
      0.2s all ease;
    }
  }
`;

const Step = ({ question, answers, handleClick, questionIndex, total }) => {
  return (
    <Wrapper>
      <FadeIn>
        <h4 className="index orange mont">Q{questionIndex}</h4>
      </FadeIn>
      <div className="question navy">{question.content}</div>
      <div className="answer-wrapper">
        {answers.map((answer, index) => (
          <AnswerButton key={index} onClick={() => handleClick(answer)}>
            {answer.content}
          </AnswerButton>
        ))}
      </div>
      <div className="pb-wrapper">
        <ProgressBar total={total} current={questionIndex - 1} />
      </div>
    </Wrapper>
  );
};

export default Step;
